export const DOCUMENT_CREATE_REQUEST = "@document.create.request";
export const DOCUMENT_CREATE_SUCCESS = "@document.create.success";
export const DOCUMENT_CREATE_FAIL = "@document.create.failure";
export const DOCUMENT_CREATE_DONE = "@document.create.done";

export const DOCUMENT_DESTROY_REQUEST = "@document.destroy.request";
export const DOCUMENT_DESTROY_SUCCESS = "@document.destroy.success";
export const DOCUMENT_DESTROY_FAIL = "@document.destroy.failure";
export const DOCUMENT_DESTROY_DONE = "@document.destroy.done";
